import React, { useState } from 'react';
import CodigoVerificacion from './codigo';

const RestablecerPorCorreo = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [showCodigo, setShowCodigo] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Mostrando código de verificación");
        setShowCodigo(true);
    };

    if (showCodigo) {
        return <CodigoVerificacion
            onClose={onClose}
            contactInfo={email}
            tipo="email"
        />;
    }

    return (
        <div className="modal-overlay">
            <div className="reset-form">
                <button className="cerrar-modal" onClick={onClose}>×</button>
                <h3>Restablecer por correo</h3>
                <form onSubmit={handleSubmit}>
                    <p>Ingresa tu correo para enviar la forma de restablecer tu contraseña</p>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Correo electrónico"
                    />
                    <button type="submit" className="boton-enviar">
                        Enviar Restablecimiento
                    </button>
                </form>
            </div>
        </div>
    );
};

export default RestablecerPorCorreo;